<template>
  <div :class="cn('tw:p-4', $attrs.class)">
    <InputGroup>
      <InputGroupInput
        v-model="composeForm.draft"
        placeholder="Ask a question"
        autocomplete="off"
        @keyup.enter.prevent="checkAndSend"
      />

      <QuickConversationFunctionsMenu v-if="limitRequests" />

      <InputGroupAddon align="inline-end">
        <InputGroupButton
          type="button"
          :disabled="composeForm.busy || composeForm.draft.length <= 0"
          size="icon-sm"
          variant="primary"
          class="tw:rounded-full"
          @pointerdown.prevent
          @click="checkAndSend"
        >
          <i class="tw:i-fal-arrow-up" />
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  </div>
</template>

<script setup>
import QuickConversationFunctionsMenu from '@/components/quick-conversation/quick-conversation-functions-menu.vue'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@/shadcn/components/ui/input-group/index.js'
import { cn } from '@/shadcn/lib/utils.js'
import { useQuickConversation } from './use-quick-conversation.js'

defineOptions({
  inheritAttrs: false,
})

const { composeForm, checkAndSend, limitRequests } = useQuickConversation()
</script>
